<script setup lang="ts">
  import {
    ref,
    defineProps,
    defineEmits,
    computed,
    watch,
    nextTick,
  } from 'vue';
  import VideoEditorMolecule from '@/components/molecules/video-editor-molecules/VideoEditorMolecule.vue';
  import VideoPreviewMolecule from '@/components/molecules/video-editor-molecules/VideoPreviewMolecule.vue';
  import viewCommentsAtom from '@/components/atoms/viewCommentsAtom.vue';
  import ViewCommentsMolecule from '@/components/molecules/view-comments-molecule/ViewCommentsMolecule.vue';
  import { useStore } from 'vuex';

  const store = useStore();

  const props = defineProps<{ initialResourceDetails: any }>();

  const previewData = ref({
    resource_name: '',
    tags: [],
    text_content: '',
  });
  const showNoCommentsModal = ref(false);

  const videoFile = ref('');

  const resource = computed(() => store.getters['resource/getResource']);
  const localResourceDetails = ref({ ...props.initialResourceDetails });

  const emit = defineEmits(['update:resourceDetails']);

  let isUpdating = false;

  watch(
    resource,
    (newValue) => {
      if (!isUpdating && newValue) {
        localResourceDetails.value = { ...newValue };
        updatePreviewData({ ...newValue });
      }
    },
    { immediate: true, deep: true },
  );

  const updateResourceDetails = (updatedDetails) => {
    if (isUpdating) return;
    isUpdating = true;

    store.commit('resource/SET_RESOURCE', updatedDetails);

    emit('update:resourceDetails', updatedDetails);

    nextTick(() => {
      isUpdating = false;
    });
  };

  function updatePreviewData(data) {
    videoFile.value = data;
  }

  function openNoCommentsModal() {
    showNoCommentsModal.value = true;
  }
</script>

<template>
  <div class="video-wrapper">
    <div class="video-editor">
      <VideoEditorMolecule
        :resourceDetails="localResourceDetails"
        @updateResourceDetails="updateResourceDetails"
        @updatePreview="updatePreviewData"
      />
    </div>
    <div class="preview-container">
      <viewCommentsAtom
        @open="openNoCommentsModal"
        :resource_id="localResourceDetails.resource_id"
      />
      <ViewCommentsMolecule
        :show="showNoCommentsModal"
        @update:show="showNoCommentsModal = $event"
        :resource_id="localResourceDetails.resource_id"
      />
      <div class="video-preview">
        <VideoPreviewMolecule
          :previewData="localResourceDetails"
          :videoFile="videoFile"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .video-wrapper {
    width: 90%;
    display: flex;
    align-items: flex-start;
    padding: 20px;
    gap: 20px;
    margin: auto;
    box-sizing: border-box;
  }

  .video-editor {
    background-color: white;
    flex: 1.5;
    border-radius: 12px;
    box-sizing: border-box;
  }

  .preview-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .video-preview {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    min-height: 500px;
    flex-grow: 1;
  }
</style>
